import type { AggregationType, Granularity, UsageSeriesList } from '../../types';

import { getSeriesTotal } from './getSeriesTotal';

type SortedDimensionTotalsProps = {
  data?: UsageSeriesList;
  aggregationType: AggregationType;
  granularity: Granularity;
};

/**
 * Returns a sorted array of [total, metadata index] tuples in descending order of usage total.
 * This can be removed once the API supports server-side sorting.
 */
export function getSortedDimensionTotals({
  data,
  aggregationType,
  granularity,
}: SortedDimensionTotalsProps): Array<[number, string]> {
  if (!data || !data.series.length || !data.metadata.length) {
    return [];
  }

  const { series, metadata } = data;
  const totals: Array<[number, string]> = [];

  for (let index = 0; index < metadata.length; index++) {
    const key = String(index);
    totals.push([getSeriesTotal({ series, aggregationType, metadataIdx: key, granularity }), key]);
  }

  return totals.sort((a, b) => b[0] - a[0]);
}
